import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { layoutActions } from '@Techedge/digitalportal-shared'
import Header from '../components/Layout/Header/Header'
import Sidebar from '../components/Layout/Sidebar/SideBar'
import MainContent from '../components/Layout/MainContent/MainContent'
import { LuxBreadcrumb, LuxButton } from '@lux/wardrobe-lib'
import Accordion from '../components/Layout/Accordion/Accordion'
import { AttachmentProps } from '../models/attachment'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '../redux/reducers/activity-execution'
import ProjectSpecs from '../components/ActivityExecution/ProjectSpecs/ProjectSpecs'
import MainInformation from '../components/ActivityExecution/MainInformation/MainInformation'
import Messaging from '../components/ActivityExecution/Messaging/Messaging'
import './NewsExecution.scss'
import { setIsFullScreen } from '../redux/actions/activity-execution'

const NewsExecution = (props: any) => {
    const { onClose, messageList, isFullScreen, setIsFullScreen } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-news-execution'

    const [activeIndexMainInfo, setActiveIndexMainInfo] = useState<any>(1)
    // const [activeIndexAction, setActiveIndexAction] = useState<0 | null>(null)
    const [activeIndexMessaging, setActiveIndexMessaging] = useState<0 | null>(null)

    // const [disabledExecution, setDisabledExecution] = useState<boolean>(false)

    const breadcrumbs: {
        id: string
        label: string
        url?: string
        disabled?: boolean
        isVisible?: boolean
        className?: string
    }[] = [
        {
            id: "0",
            label: intl.formatMessage({
                id: 'modals.new.activity.breadcrumbs.activity',
                defaultMessage: 'Activity',
            }),
            isVisible: true,
            className: 'activity selectable',
        },
        {
            id: "1",
            label: intl.formatMessage({
                id: 'modals.news_execution.breadcrumbs.project_execution',
                defaultMessage: 'Project execution',
            }),
            isVisible: true,
            disabled: true,
        },
    ]

    // PERMISSION CTA
    const footer = (
        <div className={`${componentClass}__footer`}>
            <LuxButton
                variant={'outlined'}
                text={intl.formatMessage({
                    id: 'modals.news_execution.button.save_as_in_progress',
                    defaultMessage: 'Save as in progress',
                })}
            />
            <LuxButton
                text={intl.formatMessage({
                    id: 'modals.news_execution.button.save_as_in_approval',
                    defaultMessage: 'Save as in approval',
                })}
            />
        </div>
    )

    const attachments: AttachmentProps[] = [
        {
            fileUrl:
                'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png',
            fileName: 'Uploaded File Name is visible here',
            fileExtension: 'pdf',
            showDownloadIcon: true,
        },
        {
            fileUrl:
                'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png',
            fileName: 'Uploaded File Name is visible here',
            fileExtension: 'pdf',
            showDownloadIcon: true,
        },
    ]

    const details: { value: string | number; label: string }[] = [
        {
            value: '10/10/2022',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.due_date',
                defaultMessage: 'Due date',
            }),
        },
        {
            value: '10:00 am, 10/10/2022',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.creation_time',
                defaultMessage: 'Creation Time',
            }),
        },
        {
            value: 'Communication',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.module',
                defaultMessage: 'Module',
            }),
        },
        {
            value: 'Task',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.project_type',
                defaultMessage: 'Project Type',
            }),
        },
        {
            value: 'Training',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.department',
                defaultMessage: 'Department',
            }),
        },
        {
            value: 'Mario Rossi',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.from',
                defaultMessage: 'Form',
            }),
        },
        {
            value: 'Credit Card Terminal',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.assignment',
                defaultMessage: 'Assignment',
            }),
        },
        {
            value: 'High',
            label: intl.formatMessage({
                id: 'modals.news_execution.project_specs.details.priority',
                defaultMessage: 'Priority',
            }),
        },
    ]

    const [sidebarInfo, setSidebarInfo] = useState({
        title: 'Project Specs',
        status: 'Overdue',
        subtitle: 'Request for Credit Card terminal count and device information',
        details: details,
    })

    // FUNCTIONS

    const onBack = () => {
        onClose()
    }

    // USE EFFECTS

    useEffect(() => {
        const breadcrumbActivityClick = () => {
            onClose()
        }
        let breadcrumbActivity = document.querySelector(
            '.smart-modals-header__breadcrumb nav ul li.activity'
        )
        breadcrumbActivity.addEventListener('click', breadcrumbActivityClick)
        return () => {
            breadcrumbActivity.removeEventListener('click', breadcrumbActivityClick)
        }
    }, [])

    return (
        <div className="smart-modals-fullscreen">
            <div className={componentClass} data-isfullscreen={isFullScreen}>
                <div className={`${componentClass}__header`}>
                    <Header
                        onBack={onBack}
                        onClose={onClose}
                        isFullScreen={isFullScreen}
                        onFullScreen={() => setIsFullScreen(!isFullScreen)}>
                        <LuxBreadcrumb
                            pathArray={breadcrumbs.filter((b: any) => {
                                return b.isVisible
                            })}
                        />
                        <h1 className={`${componentClass}__header-mobile`}>
                            {sidebarInfo.subtitle}
                        </h1>
                    </Header>
                </div>
                <div className={`${componentClass}__main`}>
                    {!isFullScreen && (
                        <div className={`${componentClass}__sidebar`}>
                            <Sidebar>
                                <ProjectSpecs
                                    title={sidebarInfo.title}
                                    status={sidebarInfo.status}
                                    subtitle={sidebarInfo.subtitle}
                                    details={sidebarInfo.details}
                                />
                            </Sidebar>
                        </div>
                    )}
                    <div className={`${componentClass}__content`}>
                        <MainContent footer={footer}>
                            <Accordion
                                id={1}
                                title={intl.formatMessage({
                                    id: 'modals.news_execution.main_information.title',
                                    defaultMessage: 'Main Information',
                                })}
                                extraIcon={'check'}
                                activeIndex={activeIndexMainInfo}
                                setActiveIndex={setActiveIndexMainInfo}>
                                <MainInformation
                                    title={intl.formatMessage({
                                        id: 'modals.news_execution.main_information.activity_info',
                                        defaultMessage: 'Activity info',
                                    })}
                                    description={'Ordinare la backroom.'}
                                    attachments={attachments}
                                />
                            </Accordion>
                            <Accordion
                                id={3}
                                title={intl.formatMessage({
                                    id: 'modals.news_execution.messaging.title',
                                    defaultMessage: 'Messaging',
                                })}
                                activeIndex={activeIndexMessaging}
                                setActiveIndex={setActiveIndexMessaging}
                                customIcon={
                                    messageList.filter((message) => message.isUnread).length >
                                        0 && (
                                        <div className={`${componentClass}__messaging-icon`}></div>
                                    )
                                }>
                                <Messaging />
                            </Accordion>
                        </MainContent>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    messageList: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].messageList,
    isFullScreen: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isFullScreen,
    jwt: state.userReducer.accessToken,
    mode: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].mode,
})

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => {
        dispatch(
            layoutActions.setModals({
                type: null,
                props: { id: null, isEdit: false, isClone: false },
            })
        )
    },
    setIsFullScreen: (value) => {
        dispatch(setIsFullScreen(value))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(NewsExecution)
